const pickDefaultEffectsSector = (selectedSectors, knownSectorIds) => {
  const list = Array.isArray(selectedSectors) ? selectedSectors : [];
  const matches = list.filter((s) => knownSectorIds.includes(s));
  return matches.length === 1 ? matches[0] : 'all';
};

export default pickDefaultEffectsSector;
